<section>
    <mat-card-header>
        <h3>Resumen de relación con empresa</h3>
        <button mat-icon-button (click)="closeDialog()" style="position: absolute; right: 10px;">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>
    <section class="main_content">
        <section >
            <form class="filter-section" [formGroup]="filterForm">
                <mat-form-field>
                    <mat-label>Elige el rango de días</mat-label>
                    <mat-date-range-input  [rangePicker]="picker">
                        <input matStartDate (dateInput)="changeDateInput($event)" placeholder="Día de Inicio" formControlName="start">
                        <input matEndDate (dateInput)="changeDateInput($event)" placeholder="Día de Termino" formControlName="end">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker>
                        <mat-datepicker-actions>
                            <button mat-button matDatepickerCancel>Cancelar</button>
                            <button mat-raised-button (click)="applyDateRangePicker()" color="primary" matDatepickerApply>Aplicar</button>
                          </mat-datepicker-actions>                        
                    </mat-date-range-picker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Filtro</mat-label>
                    <mat-select formControlName="selectRange" (selectionChange)="changeFilterSelect($event)">
                        <mat-option *ngFor="let filter of selectFilters"
                        [ngClass]="{'hidden': filter.value === 0}"
                        [value]="filter.value">
                        {{filter.text}}
                        </mat-option>
                    </mat-select>    
                </mat-form-field>
            </form>
        </section>
        <section *ngIf="clientDebtorRelationSummary$ | async as clientDebtorSummaryRelationSummary; else loading">
            <app-client-to-debtor-relationship-summary [clientDebtorSummary]="clientDebtorSummaryRelationSummary"></app-client-to-debtor-relationship-summary>
        </section>
    </section>
</section>

<ng-template #loading>
    <div class="spinner">
        <mat-spinner diameter="70"></mat-spinner>
    </div>
</ng-template>